// extracted by mini-css-extract-plugin
export default {"wrapper":"stylesForPic_wrapper__pQEvp","italic":"stylesForPic_italic__o3tkp","images":"stylesForPic_images__zoh8P","imageItem":"stylesForPic_imageItem__YnoZk"};